import { escapeHtml } from "./escapeHtml.js";

export function renderPageHeader({
    title,
    subtitle,
    eyebrow,
    eyebrowClass,         // optional class override on the eyebrow div (defaults to "eyebrow-label")
    rightStat,
    rightHtml = "",
    centerHtml = "",
    extraClass = "",
    titleClass = "",
    subtitleClass = "",
    headerLeftExtraHtml = "",  // optional pass-through HTML appended INSIDE header-left, after subtitle
    // When set, renders a "?" button next to the title that fires the named
    // coachmark playlist via the global click delegate wired in main.js
    // (window.__restartTour). The string must match a key in
    // coachmarkTour.js' playlist registry — e.g. 'home', 'brain', 'create',
    // 'library', 'calendar', 'campaigns', 'analytics', 'connectors'.
    // Omit to skip the button (used by chrome-less pages like login/help).
    tourPlaylist = null
}) {
    if (rightStat && rightHtml) {
        console.warn("[renderPageHeader] both rightStat and rightHtml provided; rightHtml wins.");
    }

    const eyebrowHtml = eyebrow
        ? `<div class="${eyebrowClass || 'eyebrow-label'}">${escapeHtml(eyebrow)}</div>`
        : "";

    const subtitleHtml = subtitle
        ? `<div class="page-subtitle ${subtitleClass}">${subtitle}</div>`
        : "";

    let rightSlotHtml = "";
    if (rightHtml) {
        rightSlotHtml = rightHtml;
    } else if (rightStat) {
        rightSlotHtml = `<div class="header-stat"><div class="header-stat-label">${escapeHtml(rightStat.label)}</div><div class="header-stat-value">${escapeHtml(rightStat.value)}</div></div>`;
    }

    // Inline "?" button next to the title. Click delegate is wired once in
    // main.js (`window.__restartTour`) so we don't have to attach a listener
    // per page-render.
    const tourBtnHtml = tourPlaylist
        ? `<button class="page-tour-btn" type="button" data-tour-playlist="${escapeHtml(tourPlaylist)}" aria-label="Tour this page" title="Tour this page"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></button>`
        : "";

    return `
<header class="page-header ${extraClass}">
  <div class="page-shell">
    <div class="header-content">
      <div class="header-left">
        ${eyebrowHtml}
        <h1 class="page-title ${titleClass}">${title}${tourBtnHtml}</h1>
        ${subtitleHtml}
        ${headerLeftExtraHtml}
      </div>
      <div class="header-center">${centerHtml}</div>
      <div class="header-right">${rightSlotHtml}</div>
    </div>
  </div>
</header>
  `;
}
